import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=14320fab&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=ts&"
export * from "./Tabs.vue?vue&type=script&lang=ts&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=14320fab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14320fab",
  null
  
)

export default component.exports